import UserGender from "./UserGender";
import UserBirthDate from "./UserBirthDate";
import UserPhoneNumber from "./UserPhoneNumber";

const UserInformationGroup = ({
  shouldValidateQuestionnaireSection,
}: {
  shouldValidateQuestionnaireSection: boolean;
}) => {
  return (
    <>
      <UserGender
        shouldValidateQuestionnaireSection={shouldValidateQuestionnaireSection}
      />
      <UserBirthDate
        shouldValidateQuestionnaireSection={shouldValidateQuestionnaireSection}
      />
      <UserPhoneNumber
        shouldValidateQuestionnaireSection={shouldValidateQuestionnaireSection}
      />
    </>
  );
};

export default UserInformationGroup;
